/* eslint-disable react-refresh/only-export-components */
import {Suspense} from 'react';
import * as Sentry from '@sentry/react';
import {withProfiler} from '@sentry/react';
import ChekinProSettings from 'ChekinProSettings';
import AppRouter from './Routes';
import ScrollToTop from 'utils/scrollToTop';
import AppProviders from 'context/index';
import {SplashScreen} from 'components/SplashScreen';
import {ErrorFallback} from 'components/ErrorFallback';
import {ProcessToast} from 'components/common/ProcessToast';
import {ExpireSessionCloseModal} from 'components/ExpireSessionCloseModal';
import {LivenessModelPreloader} from 'components/LivenessModelPreloader';
import {PostHogPageViewTracker} from 'analytics/posthog/PostHogPageViewTracker';
import {ExpireSessionCloseModal as KioskoExpireSessionCloseModal} from 'components/Kiosko';
import {SuspenseLoader} from '@chekin/guestapp-ui-kit';

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({error}) => <ErrorFallback error={error} />}
      onError={ChekinProSettings.events.onError}
    >
      <AppProviders>
        <ExpireSessionCloseModal />
        <KioskoExpireSessionCloseModal />
        <SplashScreen />
        <ScrollToTop />
        <PostHogPageViewTracker />
        <LivenessModelPreloader />
        <Suspense fallback={<SuspenseLoader width={80} visible />}>
          <AppRouter />
        </Suspense>
        <ProcessToast />
      </AppProviders>
    </Sentry.ErrorBoundary>
  );
}

export default withProfiler(App);
